// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// icons
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import NoteAddIcon from '@mui/icons-material/NoteAddOutlined';
// ----------------------------------------------------------------------

const regulatoryManagerConfig = [
  {
    subheader: 'Pronto Administration',
    items: [
      {
        title: 'Forms Library',
        path: PATH_DASHBOARD.prontoHousingAdministration.forms.list,
        icon: <ListAltOutlinedIcon />,
        compliance: true,
      },
      {
        title: 'Questions Library',
        path: PATH_DASHBOARD.prontoHousingAdministration.questions.list,
        icon: <LiveHelpOutlinedIcon />,
        compliance: true,
      },
      {
        title: 'Templates Library',
        path: PATH_DASHBOARD.prontoHousingAdministration.templates.list,
        icon: <DescriptionOutlinedIcon />,
        compliance: true,
      },
      {
        title: 'Certification Configuration',
        path: PATH_DASHBOARD.prontoHousingAdministration.certification_config
          .list,
        icon: <NoteAddIcon />,
        compliance: true,
      },
    ],
  },
];

export default regulatoryManagerConfig;
